import React from 'react';
import {FaBars} from 'react-icons/fa';
import {Nav, NavbarContainer, NavLogo, MobileIcon, NavMenu, NavItem, NavLinks, NavBtn, NavBtnLink} from './NavbarElements';

const Navbar = ({toggle}) => {
    return (
      <>
        <Nav>
            <NavbarContainer>
                <NavLogo to='/'>
                    云智算  
                </NavLogo>
                <MobileIcon onClick={toggle}>
                  <FaBars />
                </MobileIcon>
                <NavMenu>
                  <NavItem>
                    <NavLinks to="about">关于我们</NavLinks>
                  </NavItem>
                  <NavItem>
                    <NavLinks to="discover">项目详情</NavLinks>
                  </NavItem>
                  <NavItem>
                    <NavLinks to="services">定制服务</NavLinks>
                  </NavItem>
                  <NavItem>
                    <NavLinks to="signup">加入我们</NavLinks>
                  </NavItem>
                </NavMenu>
                <NavBtn>
                  <NavBtnLink to="/signin">了解更多</NavBtnLink>
                </NavBtn>
            </NavbarContainer>
        </Nav>
      </>
    )
}

export default Navbar